import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import ScrollToTop from './components/scroll-to-top'
import './style.css'
import './views/area/direito-shared.css'
import DireitoTributrio from './views/area/direito-tributrio'
import DireitoDoTrabalho from './views/area/direito-do-trabalho'
import DireitoBancrio from './views/area/direito-bancrio'
import DireitoImobilirio from './views/area/direito-imobilirio'
import OldReaTrabalhista from './views/ol/old-rea-trabalhista'
import DireitoPrevidencirio from './views/area/direito-previdencirio'
import DireitoDoConsumidor from './views/area/direito-do-consumidor'
import DireitoDoPassageiro from './views/area/direito-do-passageiro'
import PolticaDePrivacidade from './views/poltica-de-privacidade'
import DireitoDaSade from './views/area/direito-da-sade'
import CartoDeVisita from './views/carto-de-visita'
import DireitoDeFamlia from './views/area/direito-de-famlia'
import OldReaConsumidor from './views/old/old-rea-consumidor'
import OldAraFamiliar from './views/old/old-ara-familiar'
import OldReaTributria from './views/old/old-rea-tributria'
import OldReaEmpresarial from './views/old/old-rea-empresarial'
import OldReaImobiliaria from './views/old/old-rea-imobiliaria'
import OldReaBancria from './views/old/old-rea-bancria'
import OldReaPrevidnciria from './views/old/old-rea-previdnciria'
import Inicio from './views/inicio'
import Sobre from './views/sobre'
import OldReaSaude from './views/old/old-rea-saude'

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Switch>
        <Route component={DireitoTributrio} exact path="/area/tributario" />
        <Route component={DireitoDoTrabalho} exact path="/area/trabalho" />
        <Route component={DireitoBancrio} exact path="/area/bancario" />
        <Route component={DireitoImobilirio} exact path="/area/imobiliario" />
        <Route
          component={OldReaTrabalhista}
          exact
          path="/ol/area-trabalhista"
        />
        <Route
          component={DireitoPrevidencirio}
          exact
          path="/area/previdenciario"
        />
        <Route component={DireitoDoConsumidor} exact path="/area/consumidor" />
        <Route component={DireitoDoPassageiro} exact path="/area/passageiro" />
        <Route
          component={PolticaDePrivacidade}
          exact
          path="/poltica-de-privacidade"
        />
        <Route component={DireitoDaSade} exact path="/area/saude" />
        <Route component={CartoDeVisita} path="/card" />
        <Route component={DireitoDeFamlia} exact path="/area/familia" />
        <Route component={OldReaConsumidor} exact path="/old/area-consumidor" />
        <Route component={OldAraFamiliar} exact path="/old/area-familiar" />
        <Route component={OldReaTributria} exact path="/old/area-tributaria" />
        <Route
          component={OldReaEmpresarial}
          exact
          path="/old/area-empresarial"
        />
        <Route
          component={OldReaImobiliaria}
          exact
          path="/old/area-imobiliaria"
        />
        <Route component={OldReaBancria} exact path="/old/area-bancaria" />
        <Route
          component={OldReaPrevidnciria}
          exact
          path="/old/area-providenciaria"
        />
        <Route component={Inicio} exact path="/" />
        <Route component={Sobre} exact path="/sobre" />
        <Route component={OldReaSaude} exact path="/old/area-saude" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
